import { CanceledError } from 'axios';

/** A session fence canceled this read; it is not a missing domain resource. */
export class SessionContextCanceledError extends CanceledError<unknown> {}
